// extracted by mini-css-extract-plugin
export default {"position":"Spinner_position__rG+cg"};